import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  TextField,
  FormControlLabel,
  Typography,
  useTheme,
  makeStyles,
  Checkbox,
  Link,
  Paper,
} from "@material-ui/core";

import PhoneInput from "components/PhoneInput";

import stepStyle from "../stepStyle";

const useStyles = makeStyles((theme) => ({
  containerHeading: {
    marginBottom: theme.spacing(2),
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 20000,
      backgroundColor: theme.palette.background.default,
    },
  },
  phoneInputField: {
    borderRadius: 20000,
    backgroundColor: theme.palette.background.default,
  },
}));

const ContactDetailsStep = (props) => {
  const classes = useStyles();
  const stepClasses = stepStyle();
  const theme = useTheme();

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsValidationError, setTermsValidationError] = useState(false);

  const toggleTermsAcceptance = (event) => {
    setTermsAccepted(event.target.checked);
  };

  const validateTermsAccepted = () => {
    if (!termsAccepted) {
      props.onNotifOpen("Please accept terms and conditions to continue", {
        variant: "error",
      });

      setTermsValidationError(true);
    }
    return termsAccepted;
  };

  const handleNext = () => {
    if (!validateTermsAccepted()) {
      return false;
    }

    props.handleNext();
  };

  return (
    <>
      <Paper className={stepClasses.stepContainer}>
        <Box>
          <Typography variant="subtitle1" color="textPrimary">
            Enter your details
          </Typography>
          <Typography variant="body1" color="textSecondary">
            * required information
          </Typography>
        </Box>
        <Box
          style={{
            marginTop: theme.spacing(2),
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
          }}>
          <TextField
            fullWidth
            name="given-name"
            label="First name"
            value={props.enquiryContactDetails?.firstName?.value}
            required={props.enquiryContactDetails?.firstName?.isRequired}
            error={props.enquiryContactDetails?.firstName?.error}
            helperText={
              props.enquiryContactDetails?.firstName?.error ? "This field is required." : ""
            }
            size="small"
            variant="outlined"
            autoComplete="given-name"
            className={classes.inputField}
            InputLabelProps={{
              classes: {
                shrink: classes.shrink,
              },
            }}
            onChange={(evt) => {
              props.handleEnquiryContactDetailsChange("firstName", evt.target.value);
            }}
          />
          <TextField
            fullWidth
            name="family-name"
            label="Last name"
            size="small"
            value={props.enquiryContactDetails?.lastName?.value}
            required={props.enquiryContactDetails?.lastName?.isRequired}
            error={props.enquiryContactDetails?.lastName?.error}
            helperText={
              props.enquiryContactDetails?.lastName?.error ? "This field is required." : ""
            }
            variant="outlined"
            autoComplete="family-name"
            className={classes.inputField}
            InputLabelProps={{
              classes: {
                shrink: classes.shrink,
              },
            }}
            onChange={(evt) => {
              props.handleEnquiryContactDetailsChange("lastName", evt.target.value);
            }}
          />
          <TextField
            fullWidth
            name="email"
            label="Email"
            size="small"
            value={props.enquiryContactDetails?.email?.value}
            variant="outlined"
            autoComplete="given-name"
            required={props.enquiryContactDetails?.email?.isRequired}
            error={props.enquiryContactDetails?.email?.error}
            helperText={
              props.enquiryContactDetails?.email?.error ? "Please enter a valid email address." : ""
            }
            className={classes.inputField}
            InputLabelProps={{
              classes: {
                shrink: classes.shrink,
              },
            }}
            onChange={(evt) => {
              props.handleEnquiryContactDetailsChange("email", evt.target.value);
            }}
          />
          <Box>
            <PhoneInput
              defaultCountry="GB"
              placeholder="e.g +44 7911 123456"
              countryOptionsOrder={["GB", "|"]}
              value={props.enquiryContactDetails?.phoneNumber?.value}
              required={props.enquiryContactDetails?.phoneNumber?.isRequired}
              error={props.enquiryContactDetails?.phoneNumber?.error}
              errorHelperText={
                props.enquiryContactDetails?.phoneNumber?.error
                  ? "Please enter a valid phone number"
                  : ""
              }
              className={classes.phoneInputField}
              isV2
              onChange={(value) => {
                props.handleEnquiryContactDetailsChange("phoneNumber", value);
              }}
            />
          </Box>
          <Box>
            <FormControlLabel
              className={classNames(
                classes.termsBox,
                termsValidationError ? classes.validationFailed : null,
              )}
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={termsAccepted}
                  onChange={toggleTermsAcceptance}
                  color="primary"
                />
              }
              label={
                <Typography variant="body1" color="textPrimary">
                  I have read and confirmed the&#8287;
                  <Link href="https://molliesmotel.com/booking-terms-conditions/" target="_blank">
                    Terms & conditions
                  </Link>
                </Typography>
              }
            />
            <FormControlLabel
              className={classes.termsBox}
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={props.enquiryContactDetails?.subscribeOffers?.value}
                  onChange={(e) =>
                    props.handleEnquiryContactDetailsChange("subscribeOffers", e.target.checked)
                  }
                  color="primary"
                />
              }
              label={
                <Typography variant="body1" color="textPrimary">
                  I would like to receive exclusive offers and updates via email from Mollie&apos;s
                </Typography>
              }
            />
          </Box>
        </Box>
      </Paper>
      <Button
        className={stepClasses.nextStepCTA}
        variant="contained"
        color="primary"
        size="large"
        onClick={handleNext}>
        Send Enquiry
      </Button>
    </>
  );
};

ContactDetailsStep.propTypes = {
  enquiryContactDetails: PropTypes.object,
  handleEnquiryContactDetailsChange: PropTypes.func,
  termsValidationError: PropTypes.bool,
  termsAccepted: PropTypes.bool,
  toggleTermsAcceptance: PropTypes.func,
  handleNext: PropTypes.func.isRequired,
  onNotifOpen: PropTypes.func.isRequired,
};

export default ContactDetailsStep;
